import { useWatch } from 'react-hook-form';

import { type QuizQuoteFormValues } from '../utils/quizQuote.schema';
import {
  type FirstPurchasePromotion,
  isFirstPurchaseDiscountApplicable,
} from '../utils/quoteCalculator';

/**
 * 지금 선택한 조건에 Basic 첫 구매 할인이 실제로 붙는지. 기간 초과분은 정가로 계산한다.
 */
export function useApplicableFirstPurchasePromotion(
  promotion: FirstPurchasePromotion | null,
): FirstPurchasePromotion | null {
  const values = useWatch<QuizQuoteFormValues>() as QuizQuoteFormValues;

  return isFirstPurchaseDiscountApplicable(promotion, values)
    ? promotion
    : null;
}
